import * as React from 'react';
import { components } from 'react-select';

const NoOptionsMessage: React.SFC<any> = (props) => (
    <components.NoOptionsMessage {...props} {...props.innerProps}>
        Type to search...
    </components.NoOptionsMessage>
);

export default NoOptionsMessage;
